import React from 'react'
import { Link } from 'react-router-dom'
import { useLanguage } from '../../context/LanguageContext';

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const Footer = (props) => {
    const { t } = useLanguage();

    return (
        <footer className="wpo-site-footer">
            <div className="wpo-upper-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="widget about-widget">
                                <div className="widget-title">
                                    <h2>{t('footer.tagline')}</h2>
                                </div>
                                <div className="social-widget">
                                    <h3>{t('footer.social')}</h3>
                                    <ul>
                                        <li><a href="https://www.instagram.com/vitanimal42/" target="_blank" rel="noopener noreferrer">
                                            <i className="ti-instagram"></i>
                                        </a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="widget contact-widget">
                                <div className="widget-title">
                                    <h3>{t('footer.contact')}</h3>
                                </div>
                                <ul>
                                    <li>info@vitanimal.com.tr</li>
                                    <li>0 531 775 57 54</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>{t('footer.quickLinks')}</h3>
                                </div>
                                <ul>
                                    <li><Link onClick={ClickHandler} to="/">{t('footer.home')}</Link></li>
                                    <li><Link onClick={ClickHandler} to="/about">{t('footer.about')}</Link></li>
                                    <li><Link onClick={ClickHandler} to="/shop">{t('footer.products')}</Link></li>
                                    <li><Link onClick={ClickHandler} to="/contact">{t('footer.contactLink')}</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wpo-lower-footer">
                <div className="container-fluid">
                    <div className="row g-0">
                        <div className="col col-lg-6 col-12">
                            <p className="copyright" style={{ color: 'Black' }}>
                                Copyright &copy; 2025 <a href="https://nicheprojectagency.com" target="_blank" rel="noopener noreferrer" style={{ color: 'Black' }}>Niche Project Agency</a>. All Rights Reserved.
                            </p>
                        </div>
                        <div className="col col-lg-6 col-12">
                            <ul className="right">
                                <li><Link onClick={ClickHandler} to="/privace"><span className="rolling-text">{t('footer.privacy')}</span></Link></li>
                                <li><Link onClick={ClickHandler} to="/terms"><span className="rolling-text">{t('footer.terms')}</span></Link></li>
                                <li><Link onClick={ClickHandler} to="/about"><span className="rolling-text">{t('footer.about')}</span></Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;
